import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSTabelaprecoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getTabelaPrecoByClienteIdERP(clienteIdERP, queries) {
    try {
      const { data } = await this.api.get(`/tabela-preco/getTabelaPrecoByClienteIdERP/${clienteIdERP}`, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tabela de Preço');
    }
  }
}
